import { get } from 'js/lib/user';

import {
  ID_VERIFICATION_FINGERPRINT_ENABLED_COURSES,
  ID_VERIFICATION_FINGERPRINT_EXCLUSION_LIST,
} from 'bundles/academic-integrity/components/idv-fingerprint/constants';
import { VIVA_EXAM_ENABLED_ASSIGNMENTS } from 'bundles/academic-integrity/components/viva-exam/constants';
import AcademicIntegrityExperiments from 'bundles/epic/clients/__generated__/AcademicIntegrity';

export const excludeLearnerFromIdVerificationFingerprint = (): boolean => {
  const userId = get().id?.toString();
  if (!userId) {
    return false;
  }
  return ID_VERIFICATION_FINGERPRINT_EXCLUSION_LIST.includes(userId);
};

export const isIdVerificationFingerprintEnabled = (courseId: string): boolean => {
  if (excludeLearnerFromIdVerificationFingerprint()) {
    return false;
  }
  return ID_VERIFICATION_FINGERPRINT_ENABLED_COURSES.includes(courseId);
};

export const isVivaExamEnabled = (courseId: string, itemId: string): boolean => {
  const byCourse = VIVA_EXAM_ENABLED_ASSIGNMENTS as Record<string, Record<string, boolean> | undefined>;
  return byCourse[courseId]?.[itemId] === true;
};

export const isProctoringResultsAppEnabled = (): boolean => {
  return AcademicIntegrityExperiments.get('enableProctoringResultsAppEnabled') ?? false;
};

export const isVivaExamFeedbackEnabled = (courseId?: string): boolean => {
  if (courseId) {
    const byCourse = VIVA_EXAM_ENABLED_ASSIGNMENTS as Record<string, Record<string, boolean> | undefined>;
    return byCourse[courseId]?.feedback ?? false;
  }
  return false;
};

export const isHonorCodeAgreementV2Enabled = (): boolean => {
  return AcademicIntegrityExperiments.get('enableHonorCodeAgreementV2') ?? false;
};

/*
 * Graded Labs is fully launched, so every course is enabled rather than allowlisted. Call
 * sites with no course id keep returning false to preserve their current behavior. The
 * excluded ids belong to unit-test fixtures, which keeps their assertions on the pre-launch
 * markup. A follow-up PR https://github.com/webedx-spark/web/pull/69516 removes this helper
 * and the remaining disabled branches, so that larger cleanup can be reviewed on its own.
 */
export const isGradedLabsEnabled = (courseId?: string): boolean => {
  const exclusionTestList = ['test'];
  if (!courseId || exclusionTestList.includes(courseId)) {
    return false;
  }
  return true;
};
